"use client";

// src/motion.tsx
import * as React from "react";
import { Base } from "@stepstone-genesis/system";
import {
  LazyMotion,
  m,
  domMax
} from "@stepstone-genesis/animation-library";
var MotionBase = m.create(Base);
var Motion = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(LazyMotion, { features: domMax }, /* @__PURE__ */ React.createElement(MotionBase, { ...props, ref })));

// src/index.ts
import {
  AnimatePresence,
  LazyMotion as LazyMotion2,
  LayoutGroup,
  m as m2,
  domMax as domMax2
} from "@stepstone-genesis/animation-library";
export {
  AnimatePresence,
  LayoutGroup,
  LazyMotion2 as LazyMotion,
  Motion,
  domMax2 as domMax,
  m2 as m
};
